'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';
import PostHogPageView from './PostHogPageView';

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;
const isTests = process.env.NODE_ENV === 'test';

export const PH_ENABLE_PROFILE_UPDATES = 'enable-profile-updates';
export const PH_ENABLE_SHOP_DEVELOPMENTS = 'enable-shop-developments';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Do not allow Posthog to run in test environments
    if (!isTests && posthogKey && posthogHost) {
      posthog.init(posthogKey, {
        api_host: posthogHost,
        person_profiles: 'identified_only',
        autocapture: false, // Disable automatic event capturing
        capture_pageview: false, // Disable automatic pageview capture, as we capture manually
        capture_pageleave: true, // Enable pageleave capture
        // Potential settings to reduce feature flag usage: https://posthog.com/docs/feature-flags/cutting-costs
        advanced_disable_feature_flags_on_first_load: true, // Disable feature flags on first load
        // bootstrap: {
        //   featureFlags: {
        //     PH_ENABLE_PROFILE_UPDATES: false,
        //     PH_ENABLE_SHOP_DEVELOPMENTS: false,
        //   },
        // },
      });
    }
  }, []);

  return (
    <PHProvider client={posthog}>
      <PostHogPageView />
      {children}
    </PHProvider>
  );
}
